import { DroneLabelScore } from './DroneLabelScore';

export function droneLabelScoreToConditionScore(droneLabelScore?: DroneLabelScore) {
    switch (droneLabelScore) {
        case 'A':
            return '1';
        case 'B':
            return '2';
        case 'C':
            return '3';
        case 'D':
            return '4';
        case 'E':
            return '5';
        case 'F':
            return '6';
        case 'G':
            return '7';
        default:
            return 'U';
    }
}
